import { Link } from 'react-router-dom';
import SectionHeader from '@/components/base/SectionHeader';
import Timeline from '@/components/base/Timeline';
import { dramas } from '@/mocks/dramas';
import { STATUS_LABEL, STATUS_STYLE, categoryName, formatHeat } from '@/utils/drama';

const FEATURED_ID = 'he-yue-luo-sheng-men';

export default function TimelineSpotlight() {
  const drama = dramas.find((item) => item.id === FEATURED_ID) || dramas[0];

  return (
    <section className="px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeader
          eyebrow="时间线长这样"
          title="一出瓜，从头到尾排给你看"
          description="每个节点标注类型与日期，进度条告诉你演到了第几幕。下面是站内节点最多的一出，点开就能接着往下追。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2">
                <span
                  className={`rounded-full border px-2.5 py-1 text-xs font-medium ${STATUS_STYLE[drama.status]}`}
                >
                  {STATUS_LABEL[drama.status]}
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
                  {categoryName(drama.category)}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-bold leading-relaxed text-foreground-950">
                {drama.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{drama.summary}</p>

              <div className="mt-5">
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>当前进度</span>
                  <span className="font-medium text-foreground-800">{drama.progress}%</span>
                </div>
                <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-background-200">
                  <span
                    className="block h-full rounded-full bg-primary-500"
                    style={{ width: `${drama.progress}%` }}
                  ></span>
                </div>
              </div>

              <dl className="mt-5 space-y-2.5 text-sm">
                <div className="flex items-center justify-between">
                  <dt className="text-foreground-500">起始时间</dt>
                  <dd className="text-foreground-800">{drama.startedAt}</dd>
                </div>
                <div className="flex items-center justify-between">
                  <dt className="text-foreground-500">最近更新</dt>
                  <dd className="text-foreground-800">{drama.updatedAt}</dd>
                </div>
                <div className="flex items-center justify-between">
                  <dt className="text-foreground-500">节点数量</dt>
                  <dd className="text-foreground-800">{drama.timeline.length} 个</dd>
                </div>
                <div className="flex items-center justify-between">
                  <dt className="text-foreground-500">讨论热度</dt>
                  <dd className="flex items-center gap-1 text-foreground-800">
                    <i className="ri-fire-line text-primary-500"></i>
                    {formatHeat(drama.heat)}
                  </dd>
                </div>
              </dl>

              <Link
                to={`/drama/${drama.id}`}
                className="mt-6 inline-flex h-11 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                查看完整时间线
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </aside>

          <div className="lg:col-span-8">
            <Timeline entries={drama.timeline} />
          </div>
        </div>
      </div>
    </section>
  );
}